module.exports = __webpack_public_path__ + "img/logo-fidelidade.8e083046.png";